/**
* @license Apache-2.0
*
* Copyright (c) 2026 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import realf from './../../../../float32/real';
import imagf from './../../../../float32/imag';
import Float32Array from '@stdlib/array/float32';
import Complex64 from './../../../../float32/ctor';
import assign from './assign.js';


// VARIABLES //

var out = new Float32Array( 2 );


// MAIN //

/**
* Divides two single-precision complex floating-point numbers.
*
* @param {Complex64} z1 - complex number
* @param {Complex64} z2 - complex number
* @returns {Complex64} result
*
* @example
* import Complex64 from '@stdlib/complex/float32/ctor';
*
* var z1 = new Complex64( -13.0, -1.0 );
* var z2 = new Complex64( -2.0, 1.0 );
*
* var out = div( z1, z2 );
* // returns <Complex64>[ 5.0, 3.0 ]
*/
function div( z1, z2 ) {
	var re1;
	var re2;
	var im1;
	var im2;

	re1 = realf( z1 );
	re2 = realf( z2 );
	im1 = imagf( z1 );
	im2 = imagf( z2 );

	out = assign( re1, im1, re2, im2, out, 1, 0 );

	return new Complex64( out[ 0 ], out[ 1 ] );
}


// EXPORTS //

export default div;
